import { actions } from 'entities';

import { InvoiceWrapper } from './Wrapper';

import { useUser } from 'hooks/user';
import { useProjectProfile } from '../context';

import { SentToInvoice } from './WaitingInvoiceInfo/SentToInvoice';
import { SingleInvoiceAssign } from 'pages/PendingActions/InvoiceAssign/Single';
import { TeamProjects } from 'pages/PendingActions/InvoiceAssign/TeamProjects';
import { TwoColumnWrapper } from 'pages/PendingActions/components';

export function InvoiceNotAssigned() {
  const user = useUser();
  const { refreshProject, project } = useProjectProfile();

  const canAssign = user.team.isInvoiceTeam && user.type === 'LEADER';

  const assignInvoice = actions.invoice.assignInvoiceControl.use({
    onSuccess: refreshProject,
  });

  return (
    <InvoiceWrapper>
      {canAssign ? (
        <TwoColumnWrapper>
          <div style={{ paddingTop: '16px' }}>
            <SingleInvoiceAssign
              assign={assignInvoice.execute}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              control={{ ...project.invoice, project } as any}
            />
          </div>

          <TeamProjects />
        </TwoColumnWrapper>
      ) : (
        <SentToInvoice />
      )}
    </InvoiceWrapper>
  );
}
